import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-download-button',
  templateUrl: './download-button.component.html',
  styleUrls: ['./download-button.component.scss'],
})
export class DownloadButtonComponent implements OnInit {
  @Output() processChange = new EventEmitter<boolean>();

  @Input() process: boolean | null = false;

  constructor() {}

  ngOnInit(): void {}

  handle() {
    this.process = !this.process;
    this.processChange.emit(this.process);
  }
}
